export const updateDocuments = (action, state) => ({
	documents: {
		...action.payload,
		...((action.payload.pageNumber > state.documents.pageNumber && {
			contents: [...(state.documents?.contents || []), ...action.payload.contents],
		}) ||
			{}),
	},
});

const updateValue = ({ propName, oldValue, value }) => (propName === "open" && !oldValue) || value;

export const updateClauseNode = (clauses, clauseId, { propName, value }) =>
	(Array.isArray(clauses) &&
		clauses.map(
			(clause) =>
				(clause.id === clauseId && {
					...clause,
					[propName]: updateValue({ propName, oldValue: clause[propName], value }),
				}) || { ...clause, subClauses: updateClauseNode(clause.subClauses, clauseId, { propName, value }) }
		)) ||
	clauses;
export const updateClause = (clauses, payload, clauseId) => {
	if (payload?.length > 0) {
		return (clauses || []).map((clause) =>
			clauseId === clause.id
				? {
						...clause,
						subClauses: payload,
				  }
				: { ...clause, subClauses: updateClause(clause.subClauses, payload, clauseId) }
		);
	}
	return clauses;
};
